module.exports = __webpack_public_path__ + "img/33.01db7a21.jpg";